/**
 * How long a server-prefetched listing query counts as fresh once the browser
 * has it.
 *
 * Grid routes prefetch their first page in `getServerSideProps` and ship it in
 * `dehydratedState`. TanStack Query's global default `staleTime` is 0, so
 * without an explicit value every hydrated listing refetches on mount data it
 * already has — a second Typesense round trip sitting on the critical path to
 * first render (DEV-6490).
 *
 * Paired with `rebaseHydratedState`, which measures a hydrated entry's age from
 * delivery rather than from server render, so a CDN-cached document can't age
 * its own payload past this window.
 */
export const HYDRATED_LISTING_STALE_TIME_MS = 60_000;
